import type { SVGProps } from 'react';
const SvgArrowDropDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#arrow_drop_down_svg__a)">
      <path fill="currentColor" d="m7 10 5 5 5-5H7Z" />
    </g>
    <defs>
      <clipPath id="arrow_drop_down_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowDropDown;
